var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.415 9.442a.75.75 0 0 1 1.034-.234 4.292 4.292 0 0 1 .94 6.449l-.193.205-3.886 3.886A4.265 4.265 0 0 1 7.28 21a4.267 4.267 0 0 1-3.03-1.25 4.292 4.292 0 0 1-.192-5.853l.192-.205 1.944-1.945a.75.75 0 0 1 1.147.958l-.087.104-1.942 1.944a2.788 2.788 0 0 0 0 3.936 2.784 2.784 0 0 0 3.748.17l.187-.17 3.888-3.887a2.79 2.79 0 0 0-.486-4.324.75.75 0 0 1-.235-1.035zm1.276-5.19a4.29 4.29 0 0 1 6.058 0 4.293 4.293 0 0 1 .193 5.852l-.193.205-1.944 1.946a.75.75 0 0 1-1.147-.959l.087-.103 1.942-1.944a2.785 2.785 0 0 0 0-3.936 2.789 2.789 0 0 0-3.747-.17l-.187.17L10.865 9.2a2.787 2.787 0 0 0 .486 4.324.75.75 0 1 1-.8 1.268 4.29 4.29 0 0 1-.94-6.447l.193-.206 3.887-3.888z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyLink);
export default __webpack_public_path__ + "static/media/CopyLink.7de3309c5be4877ffddea16756a3ea61.svg";
export { ForwardRef as ReactComponent };